import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, BehaviorSubject, timer } from 'rxjs';
import { popupService } from './popup.service';
import { PopupModalService } from './popup-modal.service';
import { SvcServices } from './svc.service';
import { windowService } from '../services/window.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeOutService {

  private timeoutMinutes: number = 14; // how it should wait before the overlay gets triggered
  // timeoutMinutes = 0; // DO NOT DELIVER: for dev unit testing only
  /** Once overlay gets fired remaining 1 minute waiting time will be handled in overlay component */
  private timerSubscription: Subscription;
  private timer: Observable<number>;
  //to know whether timer gets expired and the number of times timer it gets expired
  private _count: number = 1;
  public timeoutExpired: Subject<number> = new Subject<number>();
  public redirectionTimeoutExpired: Subject<number> = new Subject<number>();
  public waitingForActionTimer: Observable<number>;
  public waitingForActionTimerSubscription: Subscription;

   // Global 60-minute timer properties (non-resettable)
   private globalTimeoutMinutes: number = 60; // 60 minutes for global timeout
  private globalSixtyMinuteTimer: Observable<number>;
  private globalSixtyMinuteTimerSubscription: Subscription;
  public globalSixtyMinuteTimeoutExpired: Subject<number> = new Subject<number>();
  private globalTimerStarted: boolean = false; 

  isSsoSignedOn: any;
  partnerDefaultURL: any;
  isPartnerCheck: boolean = false;
  private globalData: any; 
  private _invokeNgaKeepALive: boolean = false;

  public get invokeNgaKeepALive(): boolean {
    return this._invokeNgaKeepALive;
  }
  public set invokeNgaKeepALive(value: boolean) {
    this._invokeNgaKeepALive = value;
    this.startTimer(); //start timer
   
  }

  

  constructor(private popupemitter: popupService, private svcService: SvcServices, private route:ActivatedRoute, private popupModalService: PopupModalService,) {

    this.timeoutExpired.subscribe(n => {

      this.popupModalService.openPopupContent.emit({
        popupContentComponent: "timeout-popup",
        popupContentParams: {}
      });

      this.redirectionStartTimer();
    });
      
    // Subscribe to global 60-minute timeout
    this.globalSixtyMinuteTimeoutExpired.subscribe(n => {
      this.handleGlobalTimeout();
    });
       this.route.queryParams.subscribe(params => {
      if (params.siteId) {
        this.isPartnerCheck = ["plcn_bloomingdales", "plcn_macys"].includes(params.siteId.toLowerCase());
      }
    });
    //start the timer while loading itself
    // this.startTimer();
    if (!this.globalTimerStarted) {
      this.startGlobalSixtyMinuteTimer();
    }
  }
  
  
  public startTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timer = timer(this.timeoutMinutes * 60 * 1000);
    this.timerSubscription = this.timer.subscribe(n => {
      this.timerComplete(n);
    });
  }

  

  private startGlobalSixtyMinuteTimer() {
    if (this.globalTimerStarted) {
      return; // Prevent multiple starts
    }

    this.globalTimerStarted = true;
    this.globalSixtyMinuteTimer = timer(this.globalTimeoutMinutes * 60 * 1000); // 60 minutes
    this.globalSixtyMinuteTimerSubscription = this.globalSixtyMinuteTimer.subscribe(n => {
      this.globalSixtyMinuteTimerComplete(n);
    });
  }

    // Stop global timer only when application is completely closed/destroyed
    public stopGlobalSixtyMinuteTimer() {
      if (this.globalSixtyMinuteTimerSubscription) {
        this.globalSixtyMinuteTimerSubscription.unsubscribe();
        this.globalTimerStarted = false;
      }
    }


  public redirectionStartTimer() {
    if (this.waitingForActionTimerSubscription) {
      this.waitingForActionTimerSubscription.unsubscribe();
    }

    this.waitingForActionTimer = timer(60 * 1000);
    this.waitingForActionTimerSubscription = this.waitingForActionTimer.subscribe(t => {
      this.redirectionTimerComplete(t);
    })
  }

  public stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  public redirectionStopTimer() {
    if (this.waitingForActionTimerSubscription) {
      this.waitingForActionTimerSubscription.unsubscribe();
    }
  }

  public resetTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timer = timer(this.timeoutMinutes * 60 * 1000);
    this.timerSubscription = this.timer.subscribe(n => {
      this.timerComplete(n);
    });
  }

  public redirectionResetTimer() {
    if (this.waitingForActionTimerSubscription) {
      this.waitingForActionTimerSubscription.unsubscribe();
    }

    this.waitingForActionTimer = timer(60 * 1000);
    this.waitingForActionTimerSubscription = this.waitingForActionTimer.subscribe(t => {
      this.redirectionTimerComplete(t);
    })
  }

  private timerComplete(n: number) {
    this.timeoutExpired.next(++this._count);
  }

  private redirectionTimerComplete(n: number) {
    this.redirectionTimeoutExpired.next(++this._count);
  }

   // Global 60-minute timer completion handler
   private globalSixtyMinuteTimerComplete(n: number) {
    this.globalSixtyMinuteTimeoutExpired.next(++this._count);
  }

  // Handle global timeout - force application termination
  private handleGlobalTimeout() {
    
    // if(this.svcService?.getNgaSignonEnabledPartner()){
    //   return;
    // }
    
    // console.log('Global 60-minute timeout reached - terminating application session');
    
    // // Call fusion timeout
    // if (this.svcService && this.svcService.fusionTimeOutCall) {
    //   this.svcService.fusionTimeOutCall("maxtimeout").subscribe(
    //     (response) => {
    //       console.log('Global timeout call successful', response);
    //       this.forceApplicationTermination();
    //     },
    //     (error) => {
    //       console.error('Global timeout call failed', error);
    //       this.forceApplicationTermination();
    //     }
    //   );
    // } else {
    //   this.forceApplicationTermination();
    // }
    this.forceApplicationTermination();
  }

  // Force application termination after 60 minutes
  private forceApplicationTermination() {
    // Clear all timers
    this.stopTimer();
    this.redirectionStopTimer();
    this.stopGlobalSixtyMinuteTimer();
    this.globalData = this.svcService.getGlobalData();
    this.isSsoSignedOn = this.globalData.isSsoSignedOn;
    this.partnerDefaultURL = this.globalData.partnerDefaultURL;
    
    // Force redirect to sign-on or show termination message
    if (this.isSsoSignedOn == true) {
      window.location.href = this.partnerDefaultURL;
    }        
    // else if(this.svcService.getApplicationModule() === 'guestpay' && this.isPartnerCheck) {
    //   window.location.reload();
    // }
    // else {
    //   if(this.svcService?.getNgaSignonEnabledPartner()){
    //     sessionStorage.setItem('sessionTimeoutNG','true')
    //     this.svcService.redirectToNGSignOn();
        
    //   }else{
    //     this.svcService.redirectToSignon('#timeout');
    //   }
      
    // }
    
  }

  // Method to check if global timer is active
  public isGlobalTimerActive(): boolean {
    return this.globalTimerStarted;
  }

 
  // Cleanup method for component destruction
  public ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    if (this.waitingForActionTimerSubscription) {
      this.waitingForActionTimerSubscription.unsubscribe();
    }
 
  }
}


